import apiService from './apiService';

export const getLocation = async () => {
  try {
    const response = await apiService.get(`/locations`);
    return response.data;
  } catch (error) {
    console.error('Error fetching locations:', error);
    throw error;
  }
};
export const getCrossReference = async (search: string = '') => {
  try {
    const response = await apiService.get(`/crossreferences`, {
      params: search ? { search } : {},
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching cross references:', error);
    throw error;
  }
};
export const getPlantcodes = async () => {
  try {
    const response = await apiService.get(`/plantcodes`);
    return response.data;
  } catch (error) {
    console.error('Error fetching cross plant codes:', error);
    throw error;
  }
};

export const getStatus = async () => {
  try {
    const response = await apiService.get(`/HvwpIsolationStatus`);

    // Handle different response formats
    const data = Array.isArray(response.data) ? response.data : response.data?.data || [];
    return data;
  } catch (error) {
    console.error('Error fetching status data:', error);
    throw error;
  }
};

export const getKeys = async () => {
  try {
    const response = await apiService.get(`/HvwpSubstationKeys`);

    // Handle different response formats
    const data = Array.isArray(response.data) ? response.data : response.data?.data || [];
    return data;
  } catch (error) {
    console.error('Error fetching keys data:', error);
    throw error;
  }
};

export const getEarthStatus = async () => {
  try {
    const response = await apiService.get(`/HvwpEarthStatus`);

    // Handle different response formats
    const data = Array.isArray(response.data) ? response.data : response.data?.data || [];
    return data;
  } catch (error) {
    console.error('Error fetching Earth status data:', error);
    throw error;
  }
};
export const getOiReferences = async (search: string = '') => {
  try {
    const response = await apiService.get(`/oireferences`, {
      params: search ? { search } : {},
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching OI references:', error);
    throw error;
  }
};
